import forEach from 'lodash/forEach';
import isUndefined from 'lodash/isUndefined';
import { eachHierarchy } from '@Hooks/LibraryInitialization/MoreUnderscore';
import { replaceCitations } from '@Utils/String';

export function _composeFactDescription(comment = '', factItem) {
  forEach(factItem.facts, (fact, factIndex) => {
    if (!isUndefined(fact.facts) && isUndefined(fact.fields)) {
      _composeFactDescription(comment, fact);
    } else {
      // for wrapped facts we need to put an operator
      if (factIndex === 0 && factItem.logicOperator) {
        comment += ` ${factItem.logicOperator}${
          factItem.logicOperatorQualifier ? '{' + factItem.logicOperatorQualifier + '}' : ''
        } `;
      }

      // facts need to be chained by logicOperator, so check if it is not the first field
      if (factIndex > 0 && fact.logicOperator) {
        comment += ` ${fact.logicOperator}${
          fact.logicOperatorQualifier ? '{' + fact.logicOperatorQualifier + '}' : ''
        } `;
      }

      if (!isUndefined(fact.fields) && fact.fields.length) {
        forEach(fact.fields, function(field, fieldIndex) {
          comment += field.displayName + ' "' + field.value + '"';

          // fields need to be chained by fieldsLogicOperator, so if it is not the last fact item chain it
          if (fieldIndex + 1 < fact.fields.length && !isUndefined(fact.fieldsLogicOperator)) {
            comment +=
              ' ' +
              fact.fieldsLogicOperator +
              (fact.fieldsLogicOperatorQualifier ? '{' + fact.fieldsLogicOperatorQualifier + '}' : '') +
              ' ';
          }
        });

        // facts need to be chained by logicOperator, so check if it is the last field
        if (
          factIndex + 1 === factItem.facts.length &&
          !isUndefined(fact.logicOperator) &&
          !isUndefined(factItem.structures)
        ) {
          comment +=
            ' ' +
            fact.logicOperator +
            (fact.logicOperatorQualifier ? '{' + fact.logicOperatorQualifier + '}' : '') +
            ' ';
        }
      } else if (!isUndefined(fact.advancedItems) && fact.advancedItems.length) {
        comment += `"${fact.advancedItems[0].advancedExpression}"`;
      }
    }
  });

  return comment;
}

export function defineAlertDescriptionFromFactItem(factItem, context) {
  const description = `Query Builder: in ${replaceCitations(context)} - `;
  return _composeFactDescription(description, factItem);
}

export function defineAlertStructuresFromFactItem(factItem) {
  let structures = [];

  eachHierarchy(
    factItem,
    node => {
      if (node.structures) {
        structures = structures.concat(node.structures);
      }
    },
    null,
    { children: 'facts' },
  );

  return structures;
}
